import styled from 'styled-components'

export const NewsLetterDiv = styled.div `
display:flex;
justify-content:center;
text-align:center;
min-height: 300px;
background: rgba(20, 255, 170, 0.05);
width:100%;
 text-align: center;


 form {
     display: flex;
     justify-content: center;

     .input-group {
         width: 50%;
     }
 }

.news{
    display: flex;
    flex-direction: column;
    
    h3{
        font-family: Gilroy;
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
        line-height: 54px;
        
        color: #18191F;
    }
    span{
        color:#1DCDFE;
    }
    input{
        background: #FFFFFF;
        border:rgba(0, 0, 0, 0.05);
        /* box-sizing: border-box; */
        border-radius: 8px;
        box-shadow:none;
        height: 40px;
    }
    button{
        width: 40px;
        height: 40px;
        background: #1E90FF;
        border-radius: 8px;
        box-shadow:none;
        color:#FFFFFF;
        input{
            border:none;
            border-style:hidden;
            :focus{
                box-shadow: none;
            }
        }
    }
    .bt1{
        display:none;
    }
    .bt2{
        /* display:none; */
    }

}

@media(max-width:320px){
    .bt1{
        display:none;
    }
    
}

`